import type { HelpFile } from '../../types/help'
import { ParameterFormTestIds } from '../../../testids/ParameterFormTestIds'

export const parameterFormHelp: HelpFile = {
  docPage: '/docs/reporting/report-definitions',
  texts: {
    [ParameterFormTestIds.parameterForm]: 'Form for entering values for the parameters required by the selected report.',
  },
}
